const TokenKey = 'token'

export function getToken() {
  return window.localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return window.localStorage.setItem(TokenKey, token)
}

export function removeAll() {
  window.localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js